import { CustomerEntry } from '../../sdk'

export function describeCustomer(customer: CustomerEntry | undefined) {
  if (!customer) {
    return ''
  }
  if (!customer.information!.firstname && !customer.information!.lastname) {
    return customer.information!.companyName
  } else {
    return [
      customer.information!.firstname,
      customer.information!.lastname
    ].join(' ')
  }
}
